import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { AngularSplitModule } from 'angular-split';
import { DevExtremeModule } from '../devextreme.module';
import { OptionsCommonModule } from '../options-common/options-common.module';
import { EtsSymbolPickerModule } from '../symbol-picker/symbol-picker.module';
import {OptionPricingGridTemplatesService} from "./option-pricing-grid-templates.service";
import {GenericConfirmationDialogModule} from "../generic-confirmation-dialog/generic-confirmation-dialog.module";
import {OptionsPricingGridComponent} from "./options-pricing-grid.component";
import {PositionModifierComponent} from "./position-modifier.component";
import {OrdersVerificationDialogComponent} from "./orders-verification-dialog/orders-verification-dialog.component";
import {HedgingGridModule} from "../hedging-grid/hedging-grid.module";
import {NormalizingCalculatorComponent} from "./normalizing-calculator/normalizing-calculator.component";
import {OpgPriceColumnCellRendererComponent} from "./price-column-cell-renderer/opg-price-column-cell-renderer.component";
import {OpgAssignTemplatesComponent} from "./assign-templates/opg-assign-templates.component";
import {ExpirationSelectorModule} from "../expiration-selector/expiration-selector.module";
import {OpgTestingComponent} from "./opg-testing/opg-testing.component";
import {OpgTestingService} from "./opg-testing/opg-testing.service";
import {ToolbarVisibilityDialogComponent} from "./toolbar-visibility/toolbar-visibility-dialog.component";
import {HorizontalSkewModule} from "../horizontal-skew/horizontal-skew.module";
import {CopilotSharedModule} from "../copilot-shared/copilot-shared.module";
import {EtsDraggableModule} from "../draggable/ets-draggable.module";
import {OrdersRegroupModule} from "../orders-regroup-dialog/orders-regroup.module";

@NgModule({
    imports: [
        CommonModule,
        EtsSymbolPickerModule,
        AngularSplitModule,
        OptionsCommonModule,
        AgGridModule.withComponents([]),
        DevExtremeModule,
        GenericConfirmationDialogModule,
        ExpirationSelectorModule,
        HorizontalSkewModule,
        EtsDraggableModule,
        // The extracted questionnaire components (CR-20260804-001) - declared there, consumed
        // by the copilot orchestrator's template here exactly as before the extraction.
        CopilotSharedModule,
        // The OOA solution pager (CR-20260830-002), used by the verification dialog's preview.
        OrdersRegroupModule,
    ],
    exports: [
        OptionsPricingGridComponent,
        PositionModifierComponent,
        NormalizingCalculatorComponent,
        OrdersVerificationDialogComponent
    ],
   declarations: [
       OptionsPricingGridComponent,
       PositionModifierComponent,
       OrdersVerificationDialogComponent,
       NormalizingCalculatorComponent,
       OpgPriceColumnCellRendererComponent,
       OpgAssignTemplatesComponent,

       OpgTestingComponent,
       ToolbarVisibilityDialogComponent

       // The OPG Co-Pilot lives WHOLE in CopilotSharedModule since the two-copilots reversal
       // (CR-20260804-001, ruling AF) - it is the Select Copilot, shared with the HedgeMatrix
       // Select tab. This module renders it via the CopilotSharedModule import above; the
       // OPG_TRADES_SKILL provider moved there with it.
   ],
   providers: [
       // OptionPricingGridTemplatesService
       OpgTestingService
   ],
})
export class OptionsPricingGridModule { }
